import Animal from "../../components/UKG/GeneralAwareness/Animal";
import MySchool from "../../components/UKG/GeneralAwareness/MySchool";
import Seasons from "../../components/UKG/GeneralAwareness/Seasons";
import AnimalMenu from './Animal';
import SeasonsMenu from './Seasons';
import MySchoolMenu from './MySchool';
import MyHomeMenu from './MyHome';
import SenseOrganMenu from './SenseOrgan';
import BodyPartsMenu from './BodyParts';
import MyHome from "../../components/UKG/GeneralAwareness/MyHome";
import SenseOrgan from "../../components/UKG/GeneralAwareness/SenseOrgan";
import BodyParts from "../../components/UKG/GeneralAwareness/BodyParts";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/ukg/general-awareness/parts-of-body", title: "Parts of Body", component: BodyParts, subMenu: BodyPartsMenu},
    { url: "/ukg/general-awareness/sense-organ", title: "Sense Organs", component: SenseOrgan, subMenu: SenseOrganMenu},
    { url: "/ukg/general-awareness/my-home", title: "My Home", component: MyHome, subMenu: MyHomeMenu},
    //{ url: "/ukg/general-awareness/my-family", title: "My Family"},
    { url: "/ukg/general-awareness/my-school", title: "My School", component: MySchool, subMenu: MySchoolMenu},
    { url: "/ukg/general-awareness/seasons", title: "Seasons", component: Seasons, subMenu: SeasonsMenu},
    { url: "/ukg/general-awareness/animals", title: "Animals", component: Animal, subMenu: AnimalMenu},
];


export default topics;